module.exports = __webpack_public_path__ + "img/skills.9977264f.svg";